import React from "react";

interface ModalContextType {
    isOpen: boolean;
    openModal: (title: string) => void;
    closeModal: () => void;
    message: React.ReactNode,
}

const ModalContext = React.createContext<ModalContextType | undefined>(undefined);

export const ModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [message, setMessage] = React.useState<React.ReactNode>("");

    const openModal = (message: React.ReactNode) => {
        setMessage(message);
        setIsOpen(true);
    };

    const closeModal = () => {
        setMessage("");
        setIsOpen(false);
    };

    
    return (
        <ModalContext.Provider value={{ isOpen, closeModal, message, openModal }} >
            {children}
        </ModalContext.Provider>
    );
};

export const useModal = () => {
    const context = React.useContext(ModalContext);
    if (!context) {
        throw new Error("useModal must be used within a ModalProvider");
    }
    return context;
};

